import React from 'react';
import { Redirect } from 'react-router';
import { Formik } from 'formik';
import Progress from 'components/Progress';
import Form from './components/Form';
import { eateryModel, tipModel } from './models';
import { createLinkTitle } from 'utils/';
import links from 'utils/links';
import Snackbar from '@material-ui/core/Snackbar';

class Presenter extends React.Component {
  state = {
    cityNameUrl: '',
    redirect: false,
    redirectionMessage: '',
  };
  componentDidMount() {
    const { props } = this;
    const { slug } = props.match.params;

    if (slug) {
      props.fetchEateryBySlug(slug);
    }

    props.fetchAmenities();
    props.fetchCities();
    props.fetchCuisines();
    props.fetchTags();

    window.addEventListener('beforeunload', this.handleWindowBeforeUnload);
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleWindowBeforeUnload);
  }

  componentDidUpdate(prevProps) {
    if (!this.props.derived.isSaving && prevProps.derived.isSaving) {
      let self = this;
      if (this.props.derived.editedSlug.draft) {
        this.setState({
          redirect: true,
          redirectionMessage:
            'Your Draft Saved Successfully! Redirecting to Dashboard',
        });
        setTimeout(function () {
          self.props.history.push(links.contributorDashboardLink());
        }, 2000);
      } else if (this.props.derived.editedSlug.id) {
        this.setState({
          redirect: true,
          redirectionMessage:
            'Successfully updated the eatery! Redirecting to Dashboard',
        });
        setTimeout(function () {
          self.props.history.push(links.contributorDashboardLink());
        }, 2000);
      } else {
        this.setState({
          redirect: true,
          redirectionMessage:
            'Successfully added the eatery! Redirecting to Dashboard',
        });
        setTimeout(function () {
          self.props.history.push(links.contributorDashboardLink());
        }, 2000);
      }
    }
  }

  isLoading = () => {
    const { slug } = this.props.match.params;
    const {
      ambiences,
      amenities,
      cities,
      cuisines,
      dishTags,
      eatery,
    } = this.props.derived;
    // console.log(ambiences, amenities, cities, cuisines, dishTags, slug, eatery);
    return !(
      ambiences.length &&
      amenities.length &&
      cities.length &&
      cuisines.length &&
      dishTags.length &&
      (!slug || eatery)
    );
  };

  getInitialValues = () => {
    const { ambiences = [], amenities = [], eatery } = this.props.derived;
    const eateryVM = eatery ? eateryModel.toViewModel(eatery) : {};
    return {
      ...eateryModel.defaultVM,
      ...eateryVM,
      ambiences: ambiences.reduce((acc, { id, name }) => {
        const value = !!(
          eatery && eatery.ambience.find(item => item.id === id)
        );
        acc[id] = { value, label: name };
        return acc;
      }, {}),
      amenities: amenities.reduce((acc, { label }) => {
        acc[label] = !!eatery && (eatery.amenities[label] || false);
        return acc;
      }, {}),
    };
  };

  handleWindowBeforeUnload = e => {
    e.preventDefault();
    e.returnValue = '';
  };

  handleSubmit = (values, { setSubmitting }) => {
    if (!values.isPreview && !values.isSaveToDraft) {
      values.isPreview = true;
      setSubmitting(false);
      window.scrollTo(0, 0);
    } else {
      const { derived } = this.props;
      let isDerivedDraft = derived.eatery ? derived.eatery.draft : false;
      const editedEatery = {
        ...(derived.eatery || {}),
        ...eateryModel.toModel(values),
        // linkTitle: (values.id && !isDerivedDraft) ? derived.eatery.linkTitle : createLinkTitle(values.name),
        linkTitle: (values.id && !isDerivedDraft) ? derived.eatery.linkTitle : createLinkTitle(values.name),
      };

      if (values.isSaveToDraft) {
        values.isSaveToDraft = false;
      } else {
        this.shouldRedirect = true;
      }

      // getting cityname for url
      for (var i = 0; i < derived.cities.length; i++) {
        if (editedEatery.city.id.toString() === derived.cities[i].value) {
          this.setState({ cityNameUrl: derived.cities[i].label });
        }
      }

      this.props.upsertEatery(
        editedEatery,
        tipModel.toModel(values.tips, derived.eatery)
      );

      setSubmitting(false);
    }
  };

  render() {
    const { derived } = this.props;
    const showProgress = this.isLoading() || derived.isSaving;
    return (
      <div className="flex justify-center">
        <Progress
          dialog={derived.isSaving}
          message="Loading…"
          show={showProgress || !!(this.shouldRedirect && derived.editedSlug)}
        />
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={this.state.redirect}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={this.state.redirectionMessage}
        />
        {!showProgress ? (
          this.shouldRedirect && derived.editedSlug ? (
            <Redirect
              push
              to={`/eatery/${this.state.cityNameUrl}/${derived.editedSlug}`}
            />
          ) : (
              <div className="max-w-sm w-screen p-4 sm-p-6 sm-mt-12 sm-mb-12 bg-white shadow">
                <Formik
                  enableReinitialize
                  initialValues={this.getInitialValues()}
                  onSubmit={this.handleSubmit}
                  render={props => <Form {...props} derived={derived} />}
                  validate={eateryModel.validate}
                />
              </div>
            )
        ) : null}
      </div>
    );
  }
}

export default Presenter;
